import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import flowRight from 'lodash/flowRight';

import { Button } from '@eb/eds-button';
import { IconButton } from '@eb/eds-icon-button';
import { CalendarChunky, UnorderedListChunky } from '@eb/eds-iconography';
import gettext from '@eb/gettext';
import { setWindowLocation } from '@eb/http';
import { PhabButton } from '@eb/eds-phab';
import { PlusChunky } from '@eb/eds-iconography';

import './EventsScreenHeader.scss';

export const EventsScreenHeader = () => (
    <>
        <div className="eds-show-up-md eds-g-grid eds-align--center-vertical eds-l-mar-top-10">
            <div className="eds-g-cell eds-g-cell-8-12">
                <h1 className="eds-text-hm" data-spec="events-screen-heading">
                    {gettext('Events')}
                </h1>
            </div>
            <div className="eds-g-cell eds-g-cell-4-12">
                <div className="eds-align--right">
                    <EventsScreenViewSwitcher />
                    <Button style="fill" type="link" href="/create">
                        {gettext('Create Event')}
                    </Button>
                </div>
            </div>
        </div>
        <div className="eds-show-down-mn events-phab-container">
            <PhabButton
                name="create-event"
                style="fill"
                iconType={<PlusChunky />}
                onClick={setWindowLocation.bind(null, '/create')}
            />
        </div>
    </>
);

export const BaseEventsScreenViewSwitcher = ({
    shouldDisplayViewSwitcher,
    isCalendarView,
    onNavigation,
}) =>
    shouldDisplayViewSwitcher ? (
        <>
            <span className="eds-l-mar-right-2 eds-show-up-sm">
                <IconButton
                    isActive={!isCalendarView}
                    iconType={<UnorderedListChunky />}
                    title={gettext('Events List')}
                    onClick={onNavigation.bind(
                        null,
                        '/organizations/events/all',
                    )}
                />
            </span>
            <span className="eds-l-mar-right-6 eds-show-up-sm">
                <IconButton
                    isActive={isCalendarView}
                    iconType={<CalendarChunky />}
                    title={gettext('Events Calendar')}
                    onClick={onNavigation.bind(
                        null,
                        '/organizations/events/calendar',
                    )}
                />
            </span>
        </>
    ) : null;

export const EventsScreenViewSwitcher = flowRight(
    withRouter,
    connect(
        (state, props) => ({
            shouldDisplayViewSwitcher: state.featureFlags.launchCreatorCalendar,
            isCalendarView: Boolean(
                /calendar$/.exec(props?.location?.pathname ?? ''),
            ),
        }),
        (dispatch) => ({
            onNavigation(path) {
                dispatch(push(path));
            },
        }),
    ),
)(BaseEventsScreenViewSwitcher);

export default EventsScreenHeader;
